import { Table } from 'antd';
import LastTenDaysGraph from './LastTenDaysGraph';

const DescriptioinTable = ({ data, lastTenDaysData }) => {

    const columns = [
        {
            title: 'Subcategory',
            dataIndex: 'sub_category',
            key: 'sub_category',
        },
        {
            title: 'Open',
            dataIndex: 'open',
            key: 'open',
        },
        {
            title: 'Closed',
            dataIndex: 'closed',
            key: 'closed',
        },
        {
            title: 'Pending',
            dataIndex: 'pending',
            key: 'pending',
        },
        {
            title: 'Resolved',
            dataIndex: 'resolved',
            key: 'resolved',
        },
    ];

    return <>
        <div className='d-flex justify-content-between align-items-start w-100 gap-5 py-3'>
            <div className='flex-1 pt-4'>
                <Table className='border border-1 rounded p-2' dataSource={data} columns={columns} scroll={{ y: 260 }} />
            </div>
            <div style={{flex:1.4}}>
                <LastTenDaysGraph data={lastTenDaysData} />
            </div>
        </div>
     </>
}

export default DescriptioinTable;